import { render, staticRenderFns } from "./PageAvaliacaoServidor.vue?vue&type=template&id=4f5a0ccc&scoped=true"
import script from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
export * from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
import style0 from "./PageAvaliacaoServidor.vue?vue&type=style&index=0&id=4f5a0ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a0ccc",
  null
  
)

export default component.exports